import Index from '../views/Deploy/Index'

let routes = {
    path: '/deploys',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '',
            name: 'list-deploys',
            component: Index,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Pipeline',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
